import IndexStore from 'src/stores/index';
import * as apiNoStore from 'src/utils/api-no-store';
import {captureSentryException} from 'src/utils/sentry';

import logger from 'src/utils/logger';


function verifyRecaptchaToken(
  sentEventId: string,
  responseModuleId: string,
  token: string,
  meta: {
    [key: string]: string | string[];
  },
): void {
  apiNoStore
    .post(`responses/sent/${sentEventId}/${responseModuleId}/re-captcha`, {
      token,
      'user-agent': meta['user-agent'] || meta.clientUA,
      referrer: meta.referrer || meta.clientReferrer,
      ip: meta.ip,
    })
    .catch((error) => {
      logger.error(
        `Unable to verify recaptcha token for survey ${sentEventId}`,
        error.stack || error,
      );
      logRecaptchaSkipToSentry(
        `Unable to verify recaptcha token for survey ${sentEventId}`,
      );
    });
}

export function recaptchaV3Verify(
  store: IndexStore,
  sentEventId: string,
  responseModuleId: string,
  action: string,
  meta: {
    [key: string]: string | string[];
  },
): void {
  // @ts-expect-error - TS2339 - Property 'grecaptcha' does not exist on type 'Window & typeof globalThis'.
  if (window.grecaptcha) {
    // @ts-expect-error - TS2339 - Property 'grecaptcha' does not exist on type 'Window & typeof globalThis'.
    window.grecaptcha.ready(() => {
      // @ts-expect-error - TS2339 - Property 'reduxStore' does not exist on type 'IndexStore'.
      const siteKey = store.reduxStore.getState().env.vendorIds.recaptchaV3;
      // @ts-expect-error - TS2339 - Property 'grecaptcha' does not exist on type 'Window & typeof globalThis'.
      window.grecaptcha
        .execute(siteKey, {action})
        // @ts-expect-error - TS7006 - Parameter 'token' implicitly has an 'any' type.
        .then((token) => {
          verifyRecaptchaToken(sentEventId, responseModuleId, token, meta);
        })
        // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
        .catch((error) => {
          logger.error('Google recaptcha V3 verification error: ' + error);
          logRecaptchaSkipToSentry(
            'Google recaptcha V3 verification error: ' + error,
          );
        });
    });
  } else {
    logger.error('Google recaptcha V3 script not loaded');
    logRecaptchaSkipToSentry('Google recaptcha V3 script not loaded');
  }
}

export function getRecaptchaV3Token(
  store: IndexStore,
  action: string,
): Promise<string> {
  return new Promise(
    (
      resolve: (result: Promise<never>) => void,
      reject: (error?: any) => void,
    ) => {
      // @ts-expect-error - TS2339 - Property 'grecaptcha' does not exist on type 'Window & typeof globalThis'.
      if (window.grecaptcha) {
        // @ts-expect-error - TS2339 - Property 'grecaptcha' does not exist on type 'Window & typeof globalThis'.
        window.grecaptcha.ready(() => {
          // @ts-expect-error - TS2339 - Property 'reduxStore' does not exist on type 'IndexStore'.
          const siteKey = store.reduxStore.getState().env.vendorIds.recaptchaV3;
          // @ts-expect-error - TS2339 - Property 'grecaptcha' does not exist on type 'Window & typeof globalThis'.
          window.grecaptcha
            .execute(siteKey, {action})
            // @ts-expect-error - TS7006 - Parameter 'token' implicitly has an 'any' type.
            .then((token) => {
              resolve(token);
            })
            // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
            .catch((error) => {
              logger.error('Google recaptcha V3 verification error: ' + error);
              reject(error);
            });
        });
      } else {
        logger.error('Google recaptcha V3 script not loaded');
        reject(new Error('Google recaptcha V3 script not loaded'));
      }
    },
  );
}

export function logRecaptchaSkipToSentry(_error: unknown) {
  /*
    stop logging recaptcha v3 errors for now
    they're too noisy and don't have clear resolution
   */
  // captureSentryException(error, {
  //   level: 'error',
  //   tags: {
  //     context: 'RecaptchaV3',
  //   },
  //   extra: {
  //     info: error,
  //   },
  // });
}
